import { GET_TEMPLATE_DESIGNS } from '../constants';
import { EditorState, TemplateDesign } from '../types';

export const templateDesignGetters = {
  [GET_TEMPLATE_DESIGNS]: (state: EditorState): TemplateDesign[] => {
    return state.templateDesigns;
  },
};
